import gql from 'graphql-tag'

export default gql`
  mutation signatureRequestStatus($input: SignatureRequestStatusInput!) {
    signatureRequestStatus(input: $input) {
      helloSignSignatures {
        email
        name
        viewed
        signed
      }
    }
  }
`
